//Custom components
import { NumericFormat as NumberFormat } from 'react-number-format';
import StatCard from '../../../UI/Card/StatCard';

const TotalAffdForSaleUnitsProposedWidget = ({ count }: { count: number }) => {
  return (
    <StatCard
      title='Total Affd. For-Sale Units Proposed'
      stat={<NumberFormat value={count} displayType='text' thousandSeparator={true} />}
    />
  );
};

export default TotalAffdForSaleUnitsProposedWidget;
